<template>
  <v-row no-gutters>
    <v-col>
      <v-text-field
        v-if="isEditing"
        :value="value"
        @input="handleInput"
        background-color="transparent"
        flat
        full-width
        hide-details="auto"
        outlined
        :hint="label"
        persistent-hint
        dense
        :readonly="!isEditing"

        type="number"
        :min="allowNegative ? null : 0"

        :error-messages="warningMessage"
        class="rounded-2"
        :class="cssWarningClass"

        @keypress="customInputFilter"
        @paste="customInputFilter"
      />

      <span v-else class="text-break" :class="cssClass">
        {{ `${label}: ${value || 0}` }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "CourseNumberField",
  props: {
    label: null,
    value: null,
    isEditing: {
      type: Boolean,
      default: false,
    },
    isFloat: {
      type: Boolean,
      default: false,
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
    cssClass: String,
    hasWarning: {
      type: Boolean,
      default: false,
    },
    warningMessage: String,
  },
  data() {
    return {};
  },
  computed: {
    cssWarningClass() {
      return this.hasWarning ? "warning--text text-field-warning-border" : "";
    },
  },
  methods: {
    handleInput(value) {
      if (this.isFloat) {
        value = this.getFloat(value, this.allowNegative);
      } else {
        value = this.getInteger(value, this.allowNegative);
      }

      this.$emit("update:value", value);
    },
    customInputFilter: function (event) {
      this.numberInputEventFilter({
        event,
        isFloat: this.isFloat,
        allowNegative: this.allowNegative,
      });
    },
  },
};
</script>

<style scoped></style>
